import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { PatchManagerService } from '../../../services/patchmanager/patchManagerService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import { MissingPatches, SystemByPlataformList } from '../../../services/patchmanager/patchManagerModel';
import { AiOutlineApple, AiOutlineCheckCircle, AiOutlineExclamationCircle, AiOutlineWindows } from 'react-icons/ai';
import moment from 'moment';
import { PiLinuxLogo } from 'react-icons/pi';
import LcTooltip from '../../../components/Generic/LcTooltip';
import { PPInput, PPModal } from 'processor-plataform-ui';
import './index.css';
import LCDashboard from '../../../components/Data/Dashboard/LCDashboard';
import PPDropDown from '../../../components/PPDropDown';
import PPCheckBox from '../../../components/Form/PPCheckBox';
import LcLoading from '../../../components/Generic/LcLoading';
import { LiaBanSolid } from 'react-icons/lia';


const SystemListPatchManager: React.FC = (props) => {

    const patchManagerService = new PatchManagerService(props);
    const [systemList, setSystemList] = useState<SystemByPlataformList[]>([]);
    const [systemListAux, setSystemListAux] = useState<SystemByPlataformList[]>([]);
    const user = useSelector<RootState, UserState>(state => state.user);
    const [loading, setLoading] = useState<boolean>(false);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [systemSelected, setSystemSelected] = useState<SystemByPlataformList>();
    const [showFilterPanel, setShowFilterPanel] = useState<boolean>(false);
    const [hostNameFilter, setHostNameFilter] = useState<string>('');
    const [installDateFilter, setInstallDateFilter] = useState<string>('');
    const [plataformFilter, setPlataformFilter] = useState<string>('');
    const [SOLegacyFilter, setSOLegacyFilter] = useState<number>(0);
    const [rebootFilter, setRebootFilter] = useState<number>(0);
    const [statusFilter, setStatusFilter] = useState<number>(0);
    const [criticalPatchesFilter, setCriticalPatchesFilter] = useState<boolean>(false)
    const [plataformOpts, setPlataformOpts] = useState([{ label: 'Windows', value: 'windows' }, { label: "Mac", value: "mac", }, { label: 'Linux', value: 'ubuntu' }])
    const [agentStatusOpts, setAgentStatusOpts] = useState([{ label: 'Ativo', value: 1 }, { label: "Desligado", value: 2 }])
    const YesOrNoOpt = [{ label: 'Sim', value: 1 }, { label: "Não", value: 2 }]

    const columns = [
        {
            field: "hostName", headerName: "HostName", width: "15%", align: 'left', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }}>
                        {row.operationalSystem && <LcIconLink icon={
                            row.operationalSystem.toLocaleLowerCase().includes('windows') ? <AiOutlineWindows size={'1rem'} />
                                :
                                row.operationalSystem.toLocaleLowerCase().includes('mac') ? <AiOutlineApple size={'1rem'} />
                                    :
                                    <PiLinuxLogo size={'1rem'} />
                        } />}
                        <span style={{ color: '#00aee1', fontWeight: 600, cursor: 'pointer' }} onClick={() => { setModalOpen(true); setSystemSelected(row); }} className='font-4x'>{row.hostName}</span>
                    </div>
                )
            }
        },
        {
            field: "agentStatus", headerName: "Status", width: "5%", align: 'center', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return  <div style={{ width: '10px', height: '10px', borderRadius: '100%', backgroundColor: '#3ebb3f' }}></div> ;
            } 
        },
        {
            field: "healthStatus", headerName: "Saúde", width: "5%", align: 'center', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return <div>
                    <LcTooltip content={<div>{translateHealth(row.healthStatus)}</div>} position="rigth" trigger="hover">
                        <div style={{ width: '10px', height: '10px', borderRadius: '100%', backgroundColor:  translateHealthColor(row.healthStatus) }}></div>
                    </LcTooltip>
                </div>
            } 
        },
        {
            field: "lastCommunication", headerName: "Última comunicação", width: "15%", align: 'left', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return moment(row.lastCommunication).format('DD/MM/YYYY hh:mm')
            }
        },
        {
            field: "lastRebootDate", headerName: "Último reboot", width: "15%", align: 'left', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return moment(row.lastRebootDate).format('DD/MM/YYYY hh:mm')
            }
        },
        {
            field: "rebootRequired", headerName: "Reboot necessário", width: "15%", align: 'center', overflow: "visible", fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return row.rebootRequired ?
                    <LcIconLink size='small'
                        icon={<AiOutlineExclamationCircle color='#ffb530' size={18} />}
                        tooltip="Necessário reiniciar a máquina"
                        tooltipPosition='right'

                    /> : <div>-</div>
            }
        },
        {
            field: "operationalSystem", headerName: "Sistema Operacional", width: "27%", align: 'left', overflow: 'visible', fontSize: '11px',
            renderCell: (row: SystemByPlataformList) => {
                return row.legacySystem ?
                    <div className='operationalSystem'>
                        <p>{row.operationalSystem}</p>
                        <LcIconLink size='small'
                            icon={<AiOutlineExclamationCircle color='#ffb530' fontSize={'1rem'} />}
                            tooltip="Sistema legado"
                            tooltipPosition='left'
                        />
                    </div>
                    :
                    <div className='operationalSystem'>{row.operationalSystem}</div>
            }
        },
        {
            field: "missingPatches", headerName: "Patches", width: "15%", align: 'left', overflow: 'visible',
            renderCell: (row: SystemByPlataformList) => {
                let severity = calculateSeveritySum(row.missingPatches)
                return (
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <LcTooltip trigger='hover' position='left' content="Crítico">
                            <div className='severityBox' style={{ color: '#fff', backgroundColor: severity.critical > 0 ? '#dc291e' : '#e2e6f3' }}>
                                {severity.critical}
                            </div>
                        </LcTooltip>
                        <LcTooltip trigger='hover' position='left' content="Importante" >
                            <div className='severityBox' style={{ color: '#fff', backgroundColor: severity.important > 0 ? '#ffa400' : '#e2e6f3' }}>{severity.important}</div>
                        </LcTooltip>
                        <LcTooltip trigger='hover' position='left' content="Moderado" >
                            <div className='severityBox' style={{ color: '#fff', backgroundColor: severity.moderate > 0 ? '#f6de00' : '#e2e6f3' }}>{severity.moderate}</div>
                        </LcTooltip>
                        <LcTooltip trigger='hover' position='left' content="Baixo" >
                            <div className='severityBox' style={{ color: '#fff', backgroundColor: severity.low > 0 ? '#3ebb3f' : '#e2e6f3' }}>{severity.low}</div>
                        </LcTooltip>
                        <LcTooltip trigger='hover' position='rigth' content="Não classificado"  >
                            <div className='severityBox' style={{ color: '#fff', backgroundColor: severity.unclassified > 0 ? '#cccccf' : '#e2e6f3' }}>{severity.unclassified}</div>
                        </LcTooltip>
                    </div>
                )
            }
        },
    ];

    const columnsPatchDetails = [
        {
            field: "patchId", headerName: "Patch ID", width: "60px", align: 'left', overflow: 'visible',
            renderCell: (row: MissingPatches) => {
                return row.legacy ?
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                        {row.patchId}
                    </div>
                    :
                    <div style={{ display: 'flex', width: '100%', alignItems: 'left' }}>{row.patchId}</div>
            }
        }, 
        {
            field: "severity", headerName: "Severidade", width: "10%", align: 'center', overflow: 'visibled',
            renderCell: (row: MissingPatches) => {
                return <div className='severityLabelDetails' style={{ backgroundColor: translateSeverityColor(row.severity) }}>{translateSeverityLabel(row.severity)} </div>
            }
        },
        {
            field: "patchDescription", headerName: "Descrição do patch", width: "250px", align: 'left',
            renderCell: (row: MissingPatches) => <div className='overflowEllipsis'>{row.patchDescription}</div>
        },
        { field: "manufacturer", headerName: "Fabricante", width: "10%", align: 'left' }, 
        {
            field: "status", headerName: "Status", width: "10%", align: 'left',
            renderCell: (row: MissingPatches) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '-6px' }} >
                        <LcIconLink icon={row.status === '--' ?      <AiOutlineExclamationCircle color='#ffa400' /> :
                            row.status === '209' ? <AiOutlineCheckCircle color='#3ebb3f' /> :
                                <LiaBanSolid color='#dc291e' />
                        }
                        />
                        <span style={{
                            color: row.severity === 'critical' ? '#dc291e' : '',
                            fontWeight: row.severity === 'critical' ? 'bold' : '',
                        }} >{translateStatusPatch(row.status)}</span>
                    </div>
                )
            }
        },
        {
            field: "instalationDate", headerName: "Instalado em", width: "10%", align: 'left',
            renderCell: (row: MissingPatches) => {
                return moment(row.installationDate, "DD/MM/YYYY HH:mm:dd")
                    .format('DD/MM/YYYY') !== '01/01/1970' ?
                    <>{moment(row.installationDate, "DD/MM/YYYY HH:mm:dd").format('DD/MM/YYYY')} </> : '-'
            }
        },
        {
            field: "patchFile", headerName: "Arquivo do patch", width: "15%", align: 'left',
            renderCell: (row: MissingPatches) => <div className='overflowEllipsis'>{row.patchFile}</div>
        },

    ];

    const getSystemByPlatformList = async () => {
        try {
            debugger;
            const systemListResponse = await patchManagerService.GetSystemByPlatformList();
            setSystemList(systemListResponse);
            setSystemListAux(systemListResponse);
            debugger;
        } catch (error) {
            debugger;
            console.error('Error:', error);
        }
    }
    const translateStatusPatch = (status: string) => {

        const translateStatus = {
            '202': 'Ausente',
            '201': "Instalado",
            '206': "Falha"
        };
        return translateStatus[status];
    }
    const calculateSeveritySum = (data: MissingPatches[]) => {
        const severityCounts = {
            critical: 0,
            important: 0,
            moderate: 0,
            low: 0,
            unclassified: 0,
        };
        data.filter(x=>x.missing ==  "1").forEach((item) => {
            const severity = item.severity;
            if (severity == "4") {
                severityCounts.critical++;
            }
            else if (severity == "3") {
                severityCounts.important++;
            }
            else if (severity == "2") {
                severityCounts.moderate++;
            }
            else if (severity == "1") {
                severityCounts.low++;
            }
            else {
                severityCounts.unclassified++;
            }
        });

        return severityCounts;
    }

    const translateStatus = (status: string) => {
        const tranlateStatus = {
            'on': 'Ativo',
            'off': "Inativo",
        };
        return tranlateStatus[status];
    }

    const getStatusRow = (status: SystemByPlataformList) => {
        return status.agentStatus === 'on' ? '#3ebb3f' : '#dc291e';
    }
    const translateHealth = (status: string) => {
        const tranlateStatus = {
            '0': 'Unknown',
            '1': "Healthy",
            '2': "Vulnerable",
            '3': "Highly Vulnerable",
        };
    
        return tranlateStatus[status];
    }
    const translateHealthColor = (status: string) => {
        const tranlateStatusColor = {
            '4': '#ff4400', // 'Important'
            '3': '#ffa400', // 'Important'
            '2': "#f6de00",// 'Moderate' 
            '1': "#3ebb3f",//'Low'
            '0': "#cccccf",//'Unrated'
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityColor = (status: string) => {
        const tranlateStatusColor = {
            '4': '#ff4400', // 'Important'
            '3': '#ffa400', // 'Important'
            '2': "#f6de00",// 'Moderate' 
            '1': "#3ebb3f",//'Low'
            '0': "#cccccf",//'Unrated'
        };
        return tranlateStatusColor[status];
    }
    const translateSeverityLabel = (status: string) => {
        const tranlateStatusColor = {
              '4': 'Crítico'
            , '3': 'Important'
            , '2': 'Moderate'
            , '1': 'Low'
            , '0': 'Unrated'
        };
        return tranlateStatusColor[status];
    }

    useEffect(() => {
        setLoading(true)
        getSystemByPlatformList()
            .finally(() => setLoading(false))
    }, [user.ClientGroupSelected, user.refreshFlag])
     
    const card = [
        {
            id: 1,
            type: 'Custom',
            position: { ColSpan: 12, RowSpan: 12, row: 1, col: 1 },
            customContentRender: () => {
                return (
                    <LcLoading loading={loading} label='Carregando...'>
                        <LcInfiniteTable
                            rows={systemList}
                            columns={columns}
                            loadMore={() => undefined}
                            size={systemList.length}
                            hidePagination
                            fontSize='medium'
                            status={getStatusRow}
                        />
                    </LcLoading>
                )
            }
        }
    ]

    const handleFilter = () => {
        let filtered = systemListAux.filter(filter => filter.hostName.toLocaleLowerCase().includes(hostNameFilter.toLowerCase()))
        if (plataformFilter !== '') {
            filtered = filtered.filter(filter => {
                let cleanedOperationalSystem = filter.operationalSystem.trim().toLowerCase();
                let cleanedPlataformFilter = plataformFilter.trim().toLowerCase();
                return cleanedOperationalSystem.includes(cleanedPlataformFilter);
            })
        }

        if (SOLegacyFilter !== 0) {
            filtered = filtered.filter(filter => {
                if (SOLegacyFilter === 1) {
                    return filter.legacySystem === true;
                } else {
                    return filter.legacySystem === false;
                }
            })
        }

        if (rebootFilter !== 0) {
            filtered = filtered.filter(filter => {
                if (rebootFilter === 1) {
                    return filter.rebootRequired === true;
                } else {
                    return filter.rebootRequired === false;
                }
            })
        }
        if (statusFilter !== 0) {
            filtered = filtered.filter(filter => {
                if (statusFilter === 1) {
                    return filter.agentStatus === 'on';
                } else {
                    return filter.agentStatus === 'off';
                }
            })
        }

        //if (installDateFilter !== '') {
        //    let dateFilter = new Date(installDateFilter);
        //    filtered = filtered.filter(filter => {
        //        let agentDate = new Date(filter.agentInstallation)
        //        return agentDate.getTime() > dateFilter.getTime();
        //    })
        //}
        if (criticalPatchesFilter) {
            filtered = filtered.filter(patch => {
                return patch.missingPatches.some(miss => miss.severity.toLowerCase() === 'critical');
            });
        }

        setSystemList(filtered);
        setShowFilterPanel(false);
    }

    const handleClear = () => {
        setLoading(true)
        setHostNameFilter('');
        setInstallDateFilter('');
        setCriticalPatchesFilter(false);
        setPlataformFilter('');
        setRebootFilter(0);
        setSOLegacyFilter(0);
        setStatusFilter(0);
        setSystemList(systemListAux);
        setLoading(false);
    }

    const filterSystem = () => {
        return (
            <div className="right-sidepanel-filters">
                <div style={{ gridGap: '1rem' }} className="principal-filters">
                    <PPInput
                        title='Hostname'
                        type="text"
                        name="hostname"
                        value={hostNameFilter}
                        onChange={(event) => setHostNameFilter(event.target.value)}
                    />
                    <PPDropDown
                        name='plataforma'
                        options={plataformOpts}
                        title="Plataforma"
                        onChange={(event) => setPlataformFilter(event.value)}
                        value={plataformOpts.find(opt => opt.value === plataformFilter) ? plataformOpts.find(opt => opt.value === plataformFilter) : ''}

                    />
                    <div className="row space-between">
                        <PPDropDown
                            style={{ width: '50%' }}
                            name='legado'
                            options={YesOrNoOpt}
                            title="SO legado"
                            onChange={(event) => setSOLegacyFilter(event.value)}
                            value={YesOrNoOpt.find(opt => opt.value === SOLegacyFilter) ? YesOrNoOpt.find(opt => opt.value === SOLegacyFilter) : 0}
                        />
                        <PPDropDown
                            style={{ width: '50%' }}
                            name='reboot'
                            options={YesOrNoOpt}
                            title="Requer Reboot"
                            onChange={(event) => setRebootFilter(event.value)}
                            value={YesOrNoOpt.find(opt => opt.value === rebootFilter) ? YesOrNoOpt.find(opt => opt.value === rebootFilter) : 0}
                        />
                    </div>
                    <PPDropDown
                        name='status'
                        options={agentStatusOpts}
                        title="Status do agente"
                        onChange={(event) => setStatusFilter(event.value)}
                        value={agentStatusOpts.find(opt => opt.value === statusFilter) ? agentStatusOpts.find(opt => opt.value === statusFilter) : 0}
                    />
                    <PPInput type='date' value={installDateFilter} onChange={(e) => setInstallDateFilter(e.target.value)} title='Instalação do agente a partir de:' />
                    <PPCheckBox checked={criticalPatchesFilter} name='criticalPatchs' title='Possui patches críticos ausentes' onChange={(e) => setCriticalPatchesFilter(e.target.value)} />
                </div>
                <div className="row right botton" >
                    <button className='pp-button bg-info' onClick={handleClear}>Limpar</button>
                    <button className='pp-button bg-primary ml-7' onClick={handleFilter}>Filtrar</button>
                </div>
            </div>
        )
    }
    const periodSelection = {
        periods: [
            {
                label: 'Este mês', text: 'Este mês',
                fields: [
                    { name: 'currentMonth', value: 'currentMonth' }
                ],
                default: true
            }
        ],
        customPeriodType: 'month',
        onChange: () => { }
    };

    return (
        <Layout
            pageTitle='Sistemas'
            periodSelection={periodSelection}
        >
            <LCDashboard
                cards={card}
                rightSidePanel={{
                    title: 'Filtros',
                    pinned: false,
                    show: showFilterPanel,
                    content: () => filterSystem()
                }}
            />
            <PPModal visible={modalOpen} title="Detalhes do Sistema" onClose={() => setModalOpen(false)} size='large'>
                {
                    systemSelected &&
                    <div className='detailsSystemPlataform'>
                        <div className="headerSystemDetails">
                            <div className='systemDetail'>
                                <h3>{systemSelected.hostName}</h3>
                                <div>
                                    <LcIconLink icon={
                                        systemSelected.operationalSystem.toLocaleLowerCase().includes('windows') ? <AiOutlineWindows size={'.9rem'} />
                                            :
                                            systemSelected.operationalSystem.toLocaleLowerCase().includes('mac') ? <AiOutlineApple size={'.9rem'} />
                                                :
                                                <PiLinuxLogo size={'.9rem'} />
                                    } />
                                    <span>{systemSelected.operationalSystem}</span>
                                </div>
                            </div>
                            <div className='systemDetail'>
                                <p><span className="systemDetailLabel">Status do agente: </span><strong style={{ color: systemSelected.agentStatus === 'on' ? '#3ebb3f' : '#dc291e' }}>{translateStatus(systemSelected.agentStatus)} </strong></p>
                                <p><span className="systemDetailLabel">Requer reboot:</span> <strong style={{ color: systemSelected.rebootRequired ? '#3ebb3f' : '#dc291e' }}>{systemSelected.rebootRequired ? 'Sim' : 'Não'}</strong></p>
                            </div>
                            <div className='systemDetail'>
                                <p><span className="systemDetailLabel">Endereço IP: </span> {systemSelected.ip.join(', ')}</p>
                                <p><span className="systemDetailLabel">Idioma do SO: </span> {systemSelected.soLanguage}</p>
                            </div>
                            <div className='systemDetail '>
                                <p><span className="systemDetailLabel">Última comunicação:</span> {moment(systemSelected.lastCommunication).format('DD/MM/YYYY hh:mm')}</p>
                                <p> </p>
                            </div>
                        </div>
                        <div className='bodySystem'>
                            <h4>Todos patches do sistema</h4>
                            <LcInfiniteTable
                                fontSize='medium'
                                rows={systemSelected.missingPatches}
                                columns={columnsPatchDetails}
                                loadMore={() => undefined}
                                size={systemSelected.missingPatches.length}
                                hidePagination
                                height='35vh'
                                status={translateStatusPatch} 
                            />
                            {console.log(systemSelected)}
                        </div>
                    </div>
                }
            </PPModal>

        </Layout>
    );
}

export default SystemListPatchManager;